import { GeoJSONSource } from 'mapbox-gl';
import { Vessel } from '../../../models/vessels/vessel.model';
import GeoHelper from '../../../utils/geo-helpers.utils';
import MapHelpers from '../../map.utils';
import MapLayer from '../map-layer.enum';

function setVesselFeatures(
  layerId: MapLayer | string,
  vesselFeatures: Vessel[]
) {
  const features = GeoHelper.vesselsToGeoJSONFeatures(vesselFeatures);
  const geojson = GeoHelper.createGeoJSON(features);
  const source = MapHelpers.getSource(layerId) as GeoJSONSource;
  source?.setData(geojson);
}

export default setVesselFeatures;
